<template>
	<div class="banner-hea">
		<div class="banner-logo">
			<img src="../assets/phhomeimg/phhomelogo1.png" />
		</div>
		<div class="banner-option" @click="navtomore">
			<img src="../assets/phhomeimg/phomeoption.png" />
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		methods:{
			navtomore(){
				this.$router.push({path: '/phmore'})
			},
		}
	}
</script>

<style>
	.banner-hea{
		width: 7.5rem;
		height: 0.88rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0rem 0.3rem;
		box-sizing: border-box;
		position: fixed;
		top: 0;
	}
	.banner-logo{
		display: flex;
		width: 0.97rem;
		height: 0.5rem;
		
	}
	.banner-logo img{
		width: 100%;
		height: 100%;
	}
	.banner-option{
		display: flex;
		width: 0.38rem;
		height: 0.38rem;
	}
	.banner-option img{
		width: 100%;
		height: 100%;
	}
</style>
